/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropupdated1Inputs */

const en_dropupdated1 = /** @type {(inputs: Dropupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop updated`)
};

const de_dropupdated1 = /** @type {(inputs: Dropupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop aktualisiert`)
};

/**
* | output |
* | --- |
* | "Drop updated" |
*
* @param {Dropupdated1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropupdated1 = /** @type {((inputs?: Dropupdated1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropupdated1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropupdated1(inputs)
	return de_dropupdated1(inputs)
});
export { dropupdated1 as "dropUpdated" }